var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import { t } from "../../I18N";
import { switchOneUpEntity } from "../actions/actions";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from "../../UI";

import { selectIsPristine } from "../common";

const defaultProps = {
  isPristine: true,
  isLast: false,
  thesaurusName: '',
  switchOneUpEntity: (_delta, _save) => {}
};



export class OneUpEntityButtonsBase extends Component {


  renderNextButton(isPristine, btnClass) {
    return /*#__PURE__*/(
      _jsx("button", {
        type: "button",
        onClick: () => this.props.switchOneUpEntity(+1, true),
        className: `save-and-next ${!isPristine ? 'btn-success' : ''} ${btnClass}` }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "save-and-next" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Save and go to next'))
      ));

  }

  render() {
    const { isPristine } = this.props;
    const btnClass = isPristine ? 'btn btn-default btn-disabled' : 'btn btn-default';
    return /*#__PURE__*/(
      _jsx("div", { className: "content-footer" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: () => this.props.switchOneUpEntity(0, false),
        className: `cancel-edit-metadata ${!isPristine ? 'btn-danger' : ''} ${btnClass}` }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "undo" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Discard changes'))
      ), /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: () => this.props.switchOneUpEntity(0, true),
        className: `save-metadata ${btnClass}` }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "save" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Save document'))
      ),
      this.renderNextButton(isPristine, btnClass)
      ));

  }
}_defineProperty(OneUpEntityButtonsBase, "defaultProps", defaultProps);

const mapStateToProps = (state) => ({
  isPristine: selectIsPristine(state)
});

export const OneUpEntityButtons = connect(mapStateToProps, { switchOneUpEntity })(
  OneUpEntityButtonsBase
);